import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const MonitoramentoTrafegoPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>Monitoramento de Tráfego</Typography>
      <Paper sx={{ p: 3, textAlign: 'center', color: 'text.secondary', minHeight: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Typography variant="h6">Página em desenvolvimento</Typography>
      </Paper>
    </Box>
  );
};

export default MonitoramentoTrafegoPage;
